<template>
  <div>
    <b-card-text>
      対象に攻撃します。
    </b-card-text>
    <b-card title="対象">
      <b-form-group id="target" label="対象"
        label-cols="3">
        <b-form-select v-model="innerValue.arguments.target" 
          :options="[
            { value:{ '@arg':'target' }, text:'選択対象' },
            { value:{ '@arg':'player' }, text:'自己' },
          ]" />
      </b-form-group>
      <b-form-group id="range" label="追加攻撃範囲"
        label-cols="3">
        <b-form-select v-model="innerValue.arguments.rangeLoad" 
          :options="[
            { value:'targeting.load-live-enemy', text:'敵' }
          ]" />
        <b-form-input v-model="innerValue.arguments.rangeAttack" 
          type="number" :min="0" :max="9" :step="1" number />
      </b-form-group>
    </b-card>
    <b-card title="命中">
      <b-alert variant="secondary" show>
        効果量=1000 - 命中値 + 命中補正値*(回避値/1000)
      </b-alert>
      <b-form-group id="targetDice" label="基本目標値"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.targetDice" 
          type="number" :min="0" :max="99" :step="1" number />
      </b-form-group>
      <b-form-group id="dodge" label="命中補正値"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.dodge" 
          type="number" :min="0" :max="1000" :step="1" number />
      </b-form-group>
    </b-card>
    <b-card title="連鎖">
      <b-form-group id="chainAttack" label="追加攻撃回数"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.chainAttack" 
          type="number" :min="0" :max="9" :step="1" number />
      </b-form-group>
      <b-form-group id="chainDelay" label="追加攻撃遅延"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.chainDelay" 
          type="number" :min="0" :max="1000" :step="1" number />
      </b-form-group>
    </b-card>
    <b-card title="効果">
      <b-alert variant="secondary" show>
         クリティカルLvNの目標値：N×1000 - クリティカル値
      </b-alert>
      <b-form-group id="critical" label="クリティカル値"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.critical" 
          type="number" :min="0" :max="99" :step="1" number />
      </b-form-group>
      <b-form-group id="dodge" label="クリティカル倍率"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.criticalDamageRatio" 
          type="number" :min="0" :max="5.0" :step="0.1" number />
      </b-form-group>
    </b-card>
    <b-card title="威力">
      <b-alert show variant="secondary">
        効果量=(自己INT×威力係数+威力固定値)×(クリティカルLv+1) - 対象MND
      </b-alert>
      <b-form-group id="INTRatio" label="威力係数"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.INTRatio" 
          type="number" :min="0" :max="99" :step="0.1" number />
      </b-form-group>
      <b-form-group id="ADamage" label="威力固定値"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.ADamage" 
          type="number" :min="0" :max="99" :step="1" number />
      </b-form-group>
      <b-form-group id="accurate" label="減衰乱数"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.accurate" 
          type="number" :min="0" :max="1" :step="0.01" number />
      </b-form-group>
    </b-card>
    <b-card title="破壊">
      <b-form-group id="break" label="破壊力">
        <b-form-select v-model="innerValue.arguments.break" 
          :options="[
            { value:1000, text:'1000：Dot' },
            { value:1500, text:'1500：遠距離攻撃' },
            { value:1750, text:'1750' },
            { value:2000, text:'2000：近接攻撃' },
            { value:2250, text:'2250' },
            { value:2500, text:'2500：破壊' },
            { value:2750, text:'2750' },
            { value:3000, text:'3000：準SA破壊' },
            { value:3500, text:'3500：SA破壊' },
            { value:4000, text:'4000：防御破壊' },
            { value:4500, text:'4500：無敵破壊' }
          ]" number />
      </b-form-group>
    </b-card>
    <b-card title="その他">
      <b-form-group id="Delay" label="遅延"
        label-cols="3">
        <b-form-input v-model="innerValue.arguments.Delay" 
          type="number" :min="0" :max="5000" :step="1" number />
      </b-form-group>
    </b-card>
    <b-button variant="danger" size="sm"
      @click="$emit('removeCode')">
      <b-icon icon="x" />削除
    </b-button>
  </div>
</template>

<script>
const newCode = ()=>{
  return {
    player: { '@arg':'player' },
    target: { '@arg':'target' },
    dice: { '@arg':'dice' },
    targetDice: 3,

    hit:1000, dodge:1000,

    rangeAttack:0, rangeLoad:'targeting.load-live-enemy',
    chainAttack:0, chainDelay:0,

    ADamage: 1,
    accurate: 1.0,
    INTRatio: 1.0,

    critical:0, criticalDamageRatio:2.0,

    onHit:[],

    Delay:1000
  }
}
export default {
  props: {
    value: Object
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  watch: {
    'innerValue.arguments' () {
      this.$emit('input', this.innerValue)
    },
    value (v) {
      this.innerValue = v
    }
  },
  newCode
}
</script>

<style lang="scss" scoped>

</style>
